import type {ReactAction} from '@netx/core/bootstrap';
import {dispatcher} from '@netx/core-next/instance/dispatcher';
import {faTrashAlt} from '@netx/core-icons';
import {canDeleteAsset} from '../enablers';
import {AssetActionLabel} from '../locales';
import {type IAsset} from '../schema';
import {ASSET_EVENT} from './constants';

export const assetActionDeleteIcon = faTrashAlt;

/**
 * Delete asset
 * @param params
 * @returns Action
 */
export const assetActionDelete = (
	asset?: IAsset,
	params?: Partial<ReactAction>,
): ReactAction => ({
	name: 'asset-delete',
	cb: () => dispatcher.trigger(ASSET_EVENT.DELETE, asset),
	enableTest: () => canDeleteAsset(asset),
	get label() {
		return AssetActionLabel.DELETE;
	},
	icon: assetActionDeleteIcon,
	...params,
});

export default assetActionDelete;
